"use client"

import {
    BadgeCheck,
    Bell,
    ChevronsUpDown,
    CreditCard, Headphones, Infinity,
    LogOut, Moon, Settings,
    Sparkles, Sun,
} from "lucide-react"

import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "@/Components/ui/avatar.jsx"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/Components/ui/dropdown-menu.jsx"
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/Components/ui/sidebar.jsx"
import React, {useContext, useState} from "react";
import {AuthContext} from "@/Contexts/AuthProvider.jsx";
import {useNavigate} from "react-router-dom";
import Hover from "@/Components/Hover.jsx";
import {Badge} from "@/Components/ui/index.js";

export function NavUser() {
    const {isMobile} = useSidebar()

    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    if (!authContext || !authContext.user) {
        return null;
    }

    const {user, token, logout, credits, isDarkMode, toggleTheme} = authContext;
    const [avatarUrl, setAvatarUrl] = useState(user?.avatar_url || "");

    const Tag = ({tag}) => {
        let color = "bg-gray-200 text-gray-800 dark:bg-gray-900/50 dark:text-gray-300";

        if (tag === "Coudy Special") {
            color = "bg-purple-200 text-purple-700 dark:bg-purple-900/50 dark:text-purple-300";
        }
        if (tag === "Coudy Ultimate") {
            color = "bg-blue-200 text-blue-700 dark:bg-blue-900/50 dark:text-blue-300";
        }
        if (tag === "Coudy Premium") {
            color = "bg-yellow-200 text-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-300";
        }
        if (tag === "Free") {
            color = "bg-green-200 text-green-700 dark:bg-green-900/50 dark:text-green-300";
        }

        return (
            <Badge className={`text-xs ${color}`}>{tag.replace("Coudy", "").trim()}</Badge>
        );
    };

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            <Avatar className="h-8 w-8 rounded-full">
                                <AvatarImage
                                    src={avatarUrl || `https://ui-avatars.com/api/?background=random&name=${user?.username}`}
                                    alt={user.name}/>
                                <AvatarFallback className="rounded-full">PL</AvatarFallback>
                            </Avatar>
                            <div className="grid flex-1 text-left text-sm leading-tight">
                                <div className={"inline-flex gap-2 items-center mb-0.5"}>
                                    <span className="truncate font-medium">{user.name}</span>
                                    <div className="grid flex-1 text-left text-sm leading-tight">
                                        <Tag tag={user.tier}/>
                                    </div>
                                </div>

                                <span className="truncate text-xs flex items-center gap-2">{(user.tier === "Coudy Ultimate" || user.tier === "Coudy Special") ? <Infinity className={"w-5 h-5"} /> : credits} Kreditů</span>

                            </div>

                            <ChevronsUpDown className="ml-auto size-4"/>
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
                        side={isMobile ? "bottom" : "right"}
                        align="end"
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="p-0 font-normal">
                            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                                <Avatar className="h-8 w-8 rounded-lg">
                                    <AvatarImage src={user.avatar_url} alt={user.name}/>
                                    <AvatarFallback className="rounded-lg">AV</AvatarFallback>
                                </Avatar>
                                <div className="grid flex-1 text-left text-sm leading-tight">
                                    <span className="truncate font-medium">{user.name}</span>
                                    <span className="truncate text-xs">{user.email}</span>
                                </div>
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator/>
                        <DropdownMenuGroup>
                            <DropdownMenuItem onClick={() => {
                                navigate("/settings")
                            }}>
                                <Settings/>
                                Nastavení
                            </DropdownMenuItem>
                            <DropdownMenuItem onClick={() => {
                                toggleTheme()
                            }}>
                                {isDarkMode ? <Moon/> : <Sun/>}
                                Změna režimu
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator/>
                        <DropdownMenuGroup>
                            <DropdownMenuItem onClick={() => {
                                navigate("/contact")
                            }}>
                                <Headphones/>
                                Podpora
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator/>
                        <DropdownMenuItem onClick={() => {
                            logout();
                            navigate("/login");
                        }}>
                            <LogOut/>
                            Odhlásit se
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}
